import React from "react";
import { Link } from "react-router-dom";
import ButtonSignInProvider from "../../../utils/ButtonSignInProvider";

const StepRegisterWithEmail = ({
  name,
  setName,
  password,
  setPassword,
  error,
  handleEmailSignUp,
  handleGoogleSignIn,
}) => (
  <>
    <form className="register-form" onSubmit={handleEmailSignUp}>
      <h2 className="register-title">Register with Email</h2>
      {error && <p className="error-message">{error}</p>}
      <div className="register-checkbox-container">
        <input type="checkbox" className="register-checkbox" required />
        <label className="register-checkbox-label">
          I agree to the{" "}
          <Link to="/terms-conditions">Terms and Conditions</Link> and{" "}
          <Link to="/privacy">Privacy Policies</Link>.
        </label>
      </div>
      <label className="register-checkbox-label">Name & Surname:</label>
      <input
        type="text"
        placeholder="Name & Surname"
        className="register-input"
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
      />
      <label className="register-checkbox-label">Password:</label>
      <input
        type="password"
        placeholder="Password"
        className="register-input"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
      />
      <button type="submit" className="register-button">
        Register with Email
      </button>
    </form>
    <div className="register-divider"></div>
    <h2 className="register-title">Register with Google</h2>
    <div className="register-social-buttons">
      <ButtonSignInProvider
        providerName="Google"
        label="Register with Google"
        onClick={handleGoogleSignIn}
      />
    </div>
  </>
);

export default StepRegisterWithEmail;
